import { Button } from "@chakra-ui/react";
import { Eye } from "lucide-react";
import { TaxUploadHistoryItem } from "../../schema/taxes.schema";

interface Props {
    handleOpenErrors: (row: TaxUploadHistoryItem) => void;
    row: TaxUploadHistoryItem;
}

export const UTActionElements = ({ handleOpenErrors, row }: Props) => {

      return (
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleOpenErrors(row)}
        aria-label="Ver detalle"
      >
        <Eye />
      </Button>
    );
}